import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "../../utils/toast";
import { postFormDataRequest } from "../../utils/api";
import { useDropzone } from "react-dropzone";
const AddKnowledgeCategory = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    // Main Plan Data State
    const [formData, setFormData] = useState({
        cat_id: 0,
        cat_title: "",
        cat_sort_order: "",
        cat_description: "",
        cat_cover_image: null as File | null,
        cat_publish_type: 0,
    });
    const [coverPreview, setCoverPreview] = useState<string | null>(null);

    const onDrop = (acceptedFiles: File[]) => {
        const file = acceptedFiles[0];

        if (!file) return;

        setFormData(prev => ({
            ...prev,
            cat_cover_image: file
        }));

        setCoverPreview(URL.createObjectURL(file));
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            "image/*": []
        },
        multiple: false,
        maxSize: 5 * 1024 * 1024
    });

    const handlePublish = async () => {
        if (!formData.cat_title) {
            showToast.error("Title is required.");
            return;
        }

        setLoading(true);

        try {
            const payload = new FormData();

            payload.append("cat_id", String(formData.cat_id));
            payload.append("cat_title", formData.cat_title);
            payload.append("cat_sort_order", formData.cat_sort_order);
            payload.append("cat_description", formData.cat_description);
            payload.append("cat_publish_type", String(formData.cat_publish_type));

            if (formData.cat_cover_image) {
                payload.append("cat_cover_image", formData.cat_cover_image);
            }
            const res = await postFormDataRequest("/knowledge/add-knowledge-category", payload, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (res.status === "success") {
                showToast.success(res.message);
                navigate("/knowledge-base");
            } else {
                showToast.error(res.message);
            }
        } catch (error: any) {
            showToast.error(error.message || "An error occurred.");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <div className="hk-pg-wrapper">
            <div className="hk-pg-body py-0">
                <div className="page-wrap">
                    <div className="page-content ps-0">
                        <div className="page-detail-wrap">
                            <header className="page-header">
                                <div>
                                    <div className="page-title">
                                        <h2 className="mb-0">New Category</h2>
                                    </div>
                                    <p className="text-muted mb-0">Manage your documentation — categories, articles, and visibility.</p>
                                </div>
                            </header>
                            <div className="page-body">
                                <div data-simplebar className="nicescroll-bar">
                                    <div className="container-fluid">
                                        <div className="row g-3">
                                            <div className="col-lg-8">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h6>Category Details</h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row g-3">
                                                            <div className="col-lg-10">
                                                                <div className="form-group mb-0">
                                                                    <label>Title</label>
                                                                    <input type="text" name="cat_title" value={formData.cat_title} onChange={handleChange} className="form-control" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-2">
                                                                <div className="form-group mb-0">
                                                                    <label>Sort Order</label>
                                                                    <input type="text" name="cat_sort_order" value={formData.cat_sort_order} onChange={handleChange} className="form-control" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12">
                                                                <div className="form-group">
                                                                    <label>Description</label>
                                                                    <textarea name="cat_description" value={formData.cat_description} onChange={handleChange} className="form-control"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-4">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h6>Publish</h6>
                                                    </div>

                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between align-items-center">

                                                                <div className="d-flex align-items-start gap-3">
                                                                    {formData.cat_publish_type === 1 ?
                                                                        <i className="ri-eye-line fs-5 text-muted mt-1"></i>
                                                                        : <i className="ri-eye-off-line fs-5 text-muted mt-1"></i>
                                                                    }
                                                                    <div>
                                                                        <div className="fw-semibold">
                                                                            {formData.cat_publish_type === 1 ? "Published" : "Draft"}
                                                                        </div>
                                                                        <div className="text-muted small">
                                                                            {formData.cat_publish_type === 1
                                                                                ? "Visible to public docs"
                                                                                : "Hidden from public docs"}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="form-check form-switch">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        role="switch"
                                                                        checked={formData.cat_publish_type === 1}
                                                                        onChange={(e) =>
                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                cat_publish_type: e.target.checked ? 1 : 0
                                                                            }))
                                                                        }
                                                                    />
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="card-footer">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={handlePublish}
                                                            disabled={loading}
                                                        >
                                                            {loading ? 'Saving...' : 'Save'}
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h6>Cover Image</h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <div
                                                            {...getRootProps()}
                                                            className="border border-dashed rounded p-4 text-center cursor-pointer"
                                                        >
                                                            <input {...getInputProps()} />

                                                            {coverPreview ? (
                                                                <img
                                                                    src={coverPreview}
                                                                    className="img-fluid rounded"
                                                                    style={{ maxHeight: 180 }}
                                                                />
                                                            ) : (
                                                                <div>
                                                                    <p className="mb-1">
                                                                        {isDragActive
                                                                            ? "Drop image here..."
                                                                            : "Drag & drop cover image"}
                                                                    </p>
                                                                    <small className="text-muted">
                                                                        or click to browse
                                                                    </small>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AddKnowledgeCategory